.submit-button {
    margin-top: 18px;
    display: flex;
    justify-content: flex-end;
    margin-right: 24px;
    gap: 8px;
}

.wrapper {
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 16px;
    margin-bottom: 10px;
    width: 480px;
}